var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.336,
    height: 23.764,
    viewBox: "0 0 39.336 23.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6590",
    "data-name": "Group 6590",
    transform: "translate(0 0.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M-445.695,771.389l10.271,10.784-10.651,11.614",
    transform: "translate(473.391 -771.389)",
    fill: "none",
    stroke: "#f28a3a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 37.967,
    transform: "translate(0 10.724)",
    fill: "none",
    stroke: "#f28a3a",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowSmall);
export default __webpack_public_path__ + "static/media/right_arrow_small.d435d02f29392b8e39e75e6c9e5787b4.svg";
export { ForwardRef as ReactComponent };